import { FormLabel as ChakraFormLabel, FormLabelProps as ChakraFormLabelProps, Flex, Text } from '@chakra-ui/react';

interface FormLabelProps {
  optional?: boolean;
}

export default function FormLabel({ optional, children, ...formLabelProps }: FormLabelProps & ChakraFormLabelProps) {
  return (
    <ChakraFormLabel mr={0} {...formLabelProps}>
      <Flex alignItems="center">
        <Text as="span">{children}</Text>
        {optional ? (
          <Text as="span" fontWeight="light" pl={2}>
            (optional)
          </Text>
        ) : null}
      </Flex>
    </ChakraFormLabel>
  );
}
